import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
} from '@resy/ui-kitchen';
import {
  Slider, Slide, ButtonBack, ButtonNext,
} from 'pure-react-carousel';
import Chevron from '../../../../../images/icons/chevron-left.svg';
import AmexGDAB2BTestimonialsCard from '../AmexGDAB2BTestimonialsCard';
import './AmexGDAB2BTestimonialsCarousel.scss';

const AmexGDAB2BTestimonialsCarousel = (
  {
    imagePathPrefix,
    sr_title: srTitle,
    sr_info: srInfo,
    sr_controls_aria: srControlsAria,
    testimonials,
  }
) => {
  const renderButtons = () => (
    <>
      <ButtonBack
        aria-label="Previous slide"
        className="AmexGDAB2BTestimonialsCarousel__controls--buttons left"
      >
        <span aria-hidden="true">
          <Icon
            name="Chevron"
            component={Chevron}
          />
        </span>
      </ButtonBack>
      <ButtonNext
        aria-label="Next slide"
        className="AmexGDAB2BTestimonialsCarousel__controls--buttons right"
      >
        <span aria-hidden="true">
          <Icon
            name="Chevron"
            component={Chevron}
          />
        </span>
      </ButtonNext>
    </>
  );
  return (
    <div className="AmexGDAB2BTestimonialsCarousel">
      <div
        className="AmexGDAB2BTestimonialsCarousel__wrapper"
        aria-label={srTitle}
        role="region"
        aria-roledescription="carousel"
      >
        {srInfo && (
          <p className="sr-only">
            {srInfo}
          </p>
        )}
        <div
          className="AmexGDAB2BTestimonialsCarousel__controls"
          role="group"
          aria-label={srControlsAria}
        >
          {renderButtons()}
        </div>
        <Slider
          role={undefined}
          trayProps={{ role: 'listbox', 'aria-label': 'slider' }}
        >
          {testimonials.map((slide, i) => {
            const props = {
              bg_image: slide.bg_image,
              name: slide.name,
              text: slide.text,
              key: slide.name,
              imagePathPrefix,
            };
            return (
              <Slide
                index={i}
                id={`slide${i}`}
                key={slide.text}
                aria-roledescription="slide"
                aria-labelledby={`slide_heading${i}`}
              >
                <div className="AmexGDAB2BTestimonialsCard">
                  <AmexGDAB2BTestimonialsCard
                    index={i}
                    {...props}
                  />
                </div>
              </Slide>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

AmexGDAB2BTestimonialsCarousel.propTypes = {
  imagePathPrefix: PropTypes.string.isRequired,
  sr_title: PropTypes.string,
  sr_info: PropTypes.string,
  sr_controls_aria: PropTypes.string,
  testimonials: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

AmexGDAB2BTestimonialsCarousel.defaultProps = {
  sr_title: 'Testimonials carousel',
  sr_info: 'Carousel help: use the carousel controls to navigate to respective slides (below the controls).',
  sr_controls_aria: 'Testimonials carousel controls',
};

export default AmexGDAB2BTestimonialsCarousel;
